<template>
  <div id="modify-pwd">
    <div class="form-wrap">
      <el-form :model="passForm"
               :rules="pwdRules"
               ref="passForm"
               label-position="top">
        <el-form-item label="Current Password"
                      prop="oldPassword">
          <el-input v-model="passForm.oldPassword"
                    autocomplete="off"
                    type="password"
                    show-password
                    @input="changeOldPass"></el-input>
          <span v-if="isWrong"
                class="wrongMsg">{{wrongMsg}}</span>
        </el-form-item>
        <el-form-item label="New password"
                      prop="newPassword">
          <el-input v-model="passForm.newPassword"
                    autocomplete="off"
                    type="password"
                    show-password></el-input>
        </el-form-item>
        <el-form-item label="Confirm Password:"
                      prop="confirmPassword">
          <el-input v-model="passForm.confirmPassword"
                    show-password
                    type="password"></el-input>
        </el-form-item>
      </el-form>
      <el-button class="submit-btn"
                 :loading="submitLoading"
                 @click="submitForm('passForm')">Submit</el-button>
    </div>
  </div>
</template>
<script>
import './index.less';
export default {
  data() {
    var validateNewPass = (rule, value, callback) => {
      let regExp = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
      let regExp2 = new RegExp(/^[0-9a-zA-Z!@#\$%\^&\*\(\)]{6,20}$/);
      if (!value) {
        callback(new Error('please input password!'));
      } else if (!regExp.test(value)) {
        callback(new Error('passwords must contain letters and numbers'));
      } else if (!regExp2.test(value)) {
        callback(new Error('password allow letter, digit and special character like !@#$%^&*() only!'));
      } else {
        callback();
      }
    };
    var validateNewPass2 = (rule, value, callback) => {
      if (value !== this.passForm.newPassword) {
        callback(new Error("The confirmation password doesn't match the new password !"));
      } else {
        callback();
      }
    };
    return {
      passForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      pwdRules: {
        oldPassword: [
          { min: 6, max: 20, message: 'password must be between 6 and 20 characters!', trigger: 'blur' },
          { required: true, message: 'please input current password!', trigger: 'blur' },
        ],
        newPassword: [
          { min: 6, max: 20, message: 'password must be between 6 and 20 characters!', trigger: 'blur' },
          { required: true, validator: validateNewPass, trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, validator: validateNewPass, trigger: 'blur' },
          { validator: validateNewPass2, trigger: 'blur' },
          { min: 6, max: 20, message: 'password must be between 6 and 20 characters!', trigger: 'blur' },
        ],
      },
      isWrong: false,
      wrongMsg: '',
      submitLoading: false,
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.changePwd();
        } else {
          return false;
        }
      });
    },
    async changePwd() {
      this.submitLoading = true;
      try {
        await this.$api.changePwd(this.passForm);
        this.submitLoading = false;
        this.$alert('Your password has been revised successfully', 'Notice', {
          confirmButtonText: 'OK',
          customClass: 'notice-message',
        });
      } catch (e) {
        this.isWrong = true;
        this.wrongMsg = e.resultMessage;
        this.submitLoading = false;
      }
    },
    changeOldPass() {
      this.isWrong = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/global-components/ModifyPwd/index.vue